import { render, staticRenderFns } from "./untactModfiyPage.vue?vue&type=template&id=3824109f&scoped=true&"
import script from "./untactModfiyPage.vue?vue&type=script&lang=js&"
export * from "./untactModfiyPage.vue?vue&type=script&lang=js&"
import style0 from "./untactModfiyPage.vue?vue&type=style&index=0&id=3824109f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3824109f",
  null
  
)

export default component.exports